import styles from './PulsingCircleAnimation.module.scss';
import { IconCircleFilled } from '@tabler/icons-react';

export interface PulsingCircleAnimationProps {
  size?: number;
}

export default function PulsingCircleAnimation({ size = 10 }: PulsingCircleAnimationProps) {
  return (
    <div className={styles.container}>
      <IconCircleFilled className={styles.echo} color='var(--chip-blue)' size={size} />
      <IconCircleFilled className={styles.circle} color='var(--chip-blue)' size={size} />
    </div>
  );
}
